import { Link } from "react-router-dom";
import { Phone, CalendarClock } from "lucide-react";
import { business } from "@/data/site";

export default function StickyMobileCTA() {
  return (
    <div
      className="md:hidden fixed bottom-0 left-0 right-0 z-50 flex border-t border-charcoal/15"
      data-testid="sticky-mobile-cta"
    >
      <a
        href={business.phoneHref}
        data-testid="sticky-call-now"
        className="flex-[2] flex items-center justify-center gap-2 bg-rust text-cream font-heading text-xl uppercase py-4 active:bg-rust/90"
      >
        <Phone className="w-5 h-5" />
        Call Now
      </a>
      <Link
        to="/contact"
        data-testid="sticky-estimate"
        className="flex-1 flex items-center justify-center gap-1.5 bg-navy text-cream font-heading text-lg uppercase py-4 border-l border-charcoal/15 active:bg-navy/90"
      >
        <CalendarClock className="w-5 h-5" />
        Estimate
      </Link>
    </div>
  );
}
